/**
 * Created by andreyna on 8/15/2017.
 */
import BaseComponent from '../../../base/base_component';
import FPIndicatorComponentModel from './fp_indicator_component_model';
import { FP_INDICATOR_CLASSES, FREE_PLAY_FILTER_CONSTRAINTS } from './fp_indicator_consts';
import DOM from '../../../utils/dom';
import { SYSTEM_EVENTS, USER_EVENTS } from '../../../events/events';
import Event from '../../../utils/event';
import _ from '../../../utils/underscore';
import { IAlteredFreePlayVoucher } from '../voucher/free_play_voucher_consts';
import {CyClass} from '../../../../../common/cy-classes';
const indicatorView = require('./view/fp_indicator.html');

export default class FPIndicatorComponentController extends BaseComponent {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'FPIndicatorComponentController';


    /**
     * @static
     * @type {string}
     */
    static DIRECTIVE = 'cgp-directive-fp_indicator';


    /**
     * Root component selector.
     *
     * @type {string}
     * @private
     */
    _selector = 'cgp-fp-indicator-component';


    /**
     * @property
     * @type {object|null}
     * @private
     */
    _model: FPIndicatorComponentModel = null;


    /**
     * Init component
     * @param params
     */
    init(params) {
        super.init(params);
        this._model = FPIndicatorComponentModel.create(params);
        this.addClass(CyClass('cy-free-play-indicator-button'));
        this.subscribe();
    }


    /**
     *
     */
    subscribe() {
        this.onSystemEvent(SYSTEM_EVENTS.FREE_PLAY_UPDATED, (data) => {
            this._model.setFreePlayData(data);
            this._updateContent();
        });

        this.onRootElementEvent(USER_EVENTS.ON_CLICK, () => {
            if (false === this._model.getIsEnabledState()) {
                return;
            }
            const isSelected = this._model.getIsSelected();

            // open voucher message if not selectable at all or is currently not selected
            if (false === isSelected) {
                this._sendAnalytics();
                Event.fire(SYSTEM_EVENTS.FREE_PLAY_OPEN_VOUCHERS_MSG, {
                    filter: {
                        gameTypeID: this._model.getGameTypeID(),
                        excludeFreePlays: this._model.getFreePlayID() ? [this._model.getFreePlayID()] : []
                    },
                    mode: this._model.getOpenMode(),
                    openPriority: this._model.getOpenPriority(),
                    openDirection: this._model.getOpenDirection()
                });
            }

            this._updateSelection(!isSelected)
            const onSelected = this._model.getOnSelectedFn();
            if (_.isFunction(onSelected)) {
                onSelected(!isSelected);
            }
        });
    }


    /**
     * Send analytics when FreePlay indicator has been clicked and there is at least one free play voucher
     * @private
     */
    _sendAnalytics() {
        const analyticsObj = this._model.getAnalytics();
        if (analyticsObj.category) {
            Event.fire(SYSTEM_EVENTS.ANALYTIC_TRIGGER_ACTIVATED, this._model.getAnalytics());
        }
    }

    /**
     *
     * @returns {FPIndicatorComponentController}
     */
    start() {
        this.logger.debug('Start FP inicator');

        const bakedHTML = this.bake(indicatorView, {
            iconDisabled: this._model.getIndicatorIcons().disabled
        });

        this.setHTML(bakedHTML);
        super._setPropertiesSelectors();

        return this;
    }

    /**
     * Fix elements position and execute data binding
     */
    onAppendedToDOM() {
        super.onAppendedToDOM();
        this._model.setIsEnabledState(false);
        this._updateContent();
        this._initFreePlays();
    }


    /**
     * Init free plays data by received it from FreePlayService
     * @private
     */
    private _initFreePlays() {
        return this.serviceFactory.freePlayService().getFreePlayVouchers()
            .then((freePlays) => {
                this._model.setFreePlayData(freePlays);
                this._updateContent();
            });
    }


    /**
     * Retrieve free play from service and update the model
     * @private
     */
    private _updateContent() {
        const stateFilteredFP = this._filterFreePlayByConstraints(this._model.getDisplayConstraints());
        this._updateState(stateFilteredFP.length === 0 ? false : true);
    }


    /**
     * Filter new free plays
     * @private
     */
    private _filterByNewFreePlays(freePlays: IAlteredFreePlayVoucher[]) {
        return freePlays.filter((fp) => {
            return fp.isNew === true;
        });
    }


    /**
     * Filter free plays by gameTypeID
     * @param freePlays
     * @private
     */
    private _filterByGame(freePlays: IAlteredFreePlayVoucher[]) {
        const gameTypeID = this._model.getGameTypeID();
        const freePlayID = this._model.getFreePlayID();
        return freePlays.filter((fp) => {
            if (freePlayID && parseInt(freePlayID) === parseInt(fp.ID)) { // exclude currently played FreePlay voucher
                return false;
            }
            const games = fp.games.filter((gameID) => {
                return gameTypeID === gameID * 1;
            });
            return games && games.length;
        });
    }


    /**
     *
     * @param displayConstraints
     * @private
     */
    private _filterFreePlayByConstraints(displayConstraints?: string) {
        const freePlays = this._model.getFreePlayData();
        if (!displayConstraints) {
            return [];
        }

        let filteredFreePlays = freePlays && _.isArray(freePlays) ?
            this._filterByConstraint(displayConstraints, freePlays)
        : [];
        return filteredFreePlays;
    }


    /**
     * Filter free play by constraint
     * @param constraint
     * @private
     */
    private _filterByConstraint(constraint: string, freePlays: IAlteredFreePlayVoucher[]) {
        let filteredFreePlays = freePlays || [];
        switch (constraint) {
            case FREE_PLAY_FILTER_CONSTRAINTS.FREE_PLAY_EXIST:
                break;
            case FREE_PLAY_FILTER_CONSTRAINTS.CONTAINS_GAME:
                filteredFreePlays = this._filterByGame(freePlays);
                break;
            case FREE_PLAY_FILTER_CONSTRAINTS.NEW:
                filteredFreePlays = this._filterByNewFreePlays(freePlays);
                break;
        }
        return filteredFreePlays;
    }


    /**
     * Update elements and css according to the state and device type
     * @param isEnabled
     * @private
     */
    private _updateState(isEnabled: boolean) {
        const oldIsEnabled = this._model.getIsEnabledState();
        const iconEl = this.getDOMElementByClassName(FP_INDICATOR_CLASSES.ICON);
        DOM.removeClass(iconEl, this._getIconClassByState(oldIsEnabled));
        DOM.addClass(iconEl, this._getIconClassByState(isEnabled));

        if (isEnabled) {
            DOM.addClass(this.getEl(), this.getStyleSelectors().active);
        } else {
            DOM.removeClass(this.getEl(), this.getStyleSelectors().active);
        }

        this._model.setIsEnabledState(isEnabled);

        this._updateSelection(this._model.getIsSelected());
    }


    private _updateSelection(isSelected: boolean) {
        const iconEl = this.getDOMElementByClassName(FP_INDICATOR_CLASSES.ICON);
        const selectedClass = this._model.getIndicatorIcons().selected;
        DOM.removeClass(iconEl, selectedClass);
        if (isSelected) {
            DOM.addClass(iconEl, selectedClass);
            // DOM.removeClass(iconEl, this._getIconClassByNumberOfMessages(state));
        }

        this._model.setIsSelected(isSelected);
    }


    /**
     * Get icon background class by indicator state
     * @param isEnabled
     * @returns {*}
     * @private
     */
    private _getIconClassByState(isEnabled: boolean) {
        if (isEnabled) {
            return this._model.getIndicatorIcons().enabled;
        } else {
            return this._model.getIndicatorIcons().disabled;
        }
        //return state === true ? this._model.getIndicatorIcons().enabled : this._model.getIndicatorIcons().disabled;
    }

}
